import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import React from 'react';
import { MuiGridTextView } from '../MuiGridTextView';
import { MuiGridRestrictiveCell } from '../MuiGridRestrictiveCell';
import { isEmptyString } from 'lib/typeguards';

export const renderMuiGridTextView = ({ value }: GridRenderCellParams, customValue?: React.ReactNode) => (
    <MuiGridTextView>{customValue ?? value}</MuiGridTextView>
);

export const renderMuiGridRestrictiveTextView = (
    gridCellParams: GridRenderCellParams,
    customValue?: React.ReactNode,
    prompt?: string
) => (
    <MuiGridRestrictiveCell {...gridCellParams} prompt={prompt}>
        {isEmptyString(customValue) ? '-' : customValue}
    </MuiGridRestrictiveCell>
);
